<template>
  <CRow>
    <CCol col="12" md="12">
      <CCard>
        <CCardBody>
          
              <CRow>
                <CCol col="6" md="6">
                  <CCard>
                    <CCardHeader>
                      <p>
                        <img src="img/factory.svg" style="width:20px" /> Tasks
                      </p>
                    </CCardHeader>

                    <CCardBody>
                      <CDataTable
                        :items="tasksItem"
                        :fields="fields"
                        table-filter
                        items-per-page-select
                        :items-per-page="10"
                        pagination
                        clickable-rows
                        hover
                        @row-clicked="rowClicked"
                        caption="Breed"
                      />
                    </CCardBody>
                  </CCard>
                </CCol>

                <CCol col="6" md="6">
                  <CCard>
                    <CCardHeader>
                      <p>
                        <img src="img/factory.svg" style="width:20px" /> Tasks Details
                      </p>
                    </CCardHeader>
                    <CCardBody>
                      <CForm>
                        <CInput
                          label="NO"
                          v-model="no"
                          name="no"
                          id="no"
                          required
                          horizontal
                          autocomplete="name"
                        />

                        <CInput
                          label="Tasks"
                          v-model="tasks"
                          name="tasks"
                          id="tasks"
                          required
                          horizontal
                          autocomplete="name"
                        />
                         <CInput
                          label="Days"
                          v-model="days"
                          name="days"
                          id="days"
                          required
                          horizontal
                          autocomplete="name"
                        />
                      </CForm>
                    </CCardBody>
                    <CCardFooter>
                      <CButton color="info" style="width:100px" v-if="addtaskButton" @click="addBreed">
                        <CIcon name="cilPencil" />&nbsp;Add
                      </CButton>&nbsp;
                      <CButton
                        color="success"
                        style="width:100px"
                        v-if="savetaskButton"
                        @click="updateBreed"
                      >
                        <CIcon name="cilCheck" />&nbsp;Save
                      </CButton>&nbsp;
                      <CButton
                        color="danger"
                        style="width:100px"
                        v-if="deleteButton"
                        @click="deleteBreed"
                      >
                        <CIcon name="cilXCircle" />&nbsp;Delete
                      </CButton>&nbsp;
                      <CButton
                        color="success"
                        style="width:100px"
                        v-if="EditsaveButton"
                        @click="addBreed"
                      >
                        <CIcon name="cilCheck" />&nbsp;Save
                      </CButton>
&nbsp;
                      <CButton
                        color="secondary"
                        style="width:100px"
                        v-if="cancelButton"
                        @click="CancelBreed"
                      >
                        <CIcon name="cilWarning" />&nbsp;Cancel
                      </CButton>&nbsp;
                      <CButton color="info" v-if="addnewButton" @click="addBreedplus">
                        <CIcon name="cilPencil" />&nbsp;Add New
                      </CButton>
                    </CCardFooter>
                  </CCard>
                </CCol>
              </CRow>
            
             
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../../tables/Table";
import { APIService } from "../../../apiservice.js";
import Swal from "sweetalert2";
export default {
  components: { CTableWrapper },

  data() {
    return {
      no: null,
      tasks: "",
      days: "",
      tasksItem: [],
      editBreed: [],
      options: ["", "Cow", "Buffalo"],
      tabs: ["Breed Details", "Tasks"],
      addtaskButton: true,
      savetaskButton: false,
      deleteButton: false,
      addnewButton: false,
      cancelButton: false,
      EditsaveButton: false,
      fields: [
        {
          key: "no",
          sortable: true
        },
        {
          key: "tasks",
          sortable: true
        },
        {
          key: "days",
          sortable: true
        }
      ],
      
      fields1: [
        {
          key: "No",
          sortable: true
        },
        {
          key: "Task",
          sortable: true
        },
        {
          key: "Days",
          sortable: true
        }
      ],
     
    };
  },
  methods: {
  gettasksList(){
      APIService.tasksList().then(res => {
        if (res.status == 200) {
          this.tasksItem = res.data;
        }
      });
    },
   
    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.editBreed = item;
      this.no = item.no;
      this.tasks = item.tasks;
      this.days = item.days;
      this.addtaskButton = false;
      this.savetaskButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
    },
    addBreed() {
      let no = this.no;
      let tasks = this.tasks;
      let days = this.days;
      let data = {
        no,
        tasks,
        days
      };
      APIService.saveTasks(data).then(res => {
        if (res.status == 200) {
          this.no = null;
          this.tasks = "";
          this.days = "";
         this.gettasksList();
          Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    addBreedplus() {
      this.no = null;
      this.tasks = "";
      this.days = "";
      this.addtaskButton = false;
      this.savetaskButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      (this.EditsaveButton = true), this.gettasksList();
    },

    CancelBreed() {
      this.no = null;
      this.tasks = "";
      this.days = "";
      this.addtaskButton = true;
      this.savetaskButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = false;
      (this.EditsaveButton = false), this.gettasksList();
    },
    updateBreed() {
      let id = this.editBreed._id;
     let no = this.no;
      let tasks = this.tasks;
      let days = this.days;
      let value = {
           no,
        tasks,
        days
      };
      let data = { id, value };
      APIService.tasksUpdate(data).then(res => {
        if (res.status == 200) {
           this.no = null;
      this.tasks = "";
      this.days = "";
          this.addtaskButton = true;
          this.savetaskButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = false;
          this.gettasksList();
           Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    deleteBreed() {
      const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: false
})

swalWithBootstrapButtons.fire({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
  cancelButtonText: 'No, cancel!',
  reverseButtons: true
}).then((result) => {
  if (result.value) {
    swalWithBootstrapButtons.fire(
      'Deleted!',
      'Your file has been deleted.',
      'success'
    )
     this.delete();
  } else if (
    /* Read more about handling dismissals below */
    result.dismiss === Swal.DismissReason.cancel
  ) {
    swalWithBootstrapButtons.fire(
      'Cancelled',
      'Your imaginary file is safe :)',
      'error'
    )
  }
})

    },

    delete(){
      let id = this.editBreed._id;
      let data = { id };
      APIService.tasksDelete(data).then(res => {
        if (res.status == 200) {
          this.no = null;
      this.tasks = "";
      this.days = "";
          this.addtaskButton = true;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = false;
          (this.EditsaveButton = false),  this.gettasksList();
        }
      });
    }
  },
  created() {
    this.gettasksList();
  }
};
</script>
